// @flow

import React from 'react';
import styled, { withTheme } from 'styled-components';
import type { Theme } from '../../../../../../../types';
import type { PackageContainee } from '../../../../../../../types/pdb';
import ListContainer from '../../../../../../list';
import Divider from '../../../../../../divider';
import HighlightsTitle from './highlightsTitle';

type Contains = Array<PackageContainee>;

const StyledList = styled<typeof ListContainer, Theme, _>(ListContainer)`
  color: inherit;
`;

export type Props = {|
  items: Contains,
  active: boolean,
  title: string,
  theme: any,
|};

const HighLights = ({
  items,
  active,
  title,
  theme,
}: Props) => {
  const { configPackage } = (theme: Theme);
  return (items.length > 0
    ? [
      <Divider
        marginTop=".75rem"
        marginBottom=".75rem"
        width="100%"
        key="divider"
      />,
      <HighlightsTitle key="title">
        {title}
      </HighlightsTitle>,
      <StyledList
        key="list"
        active={active}
        listStyle="icons"
        items={items.map(item => ({ icon: 'plus', usp: item.name }))}
        compact
        iconColor={active ? 'currentColor' : configPackage.highlights.iconColor}
      />,
    ]
    : null
  );
};

export default withTheme(HighLights);
